// theme.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private themeColor: string = '';
  private themeSubject = new BehaviorSubject<string>('');
  public theme$ = this.themeSubject.asObservable();

  constructor() {
    this.detectTheme();
  }

  detectTheme() {
    const rootStyles = getComputedStyle(document.documentElement);
    this.themeColor = rootStyles.getPropertyValue('--primary_Bg_Button_Color').trim();
    this.themeSubject.next(this.themeColor);
  }

  isBlueTheme(): boolean {
    return this.themeColor === '#1D49C4';
  }

  getThemeColor(): string {
    return this.themeColor;
  }
}